import { LuLayoutDashboard } from "react-icons/lu";
import { Dashboard } from "@/pages/dashboard";
import { Profile } from "@/pages/profile";
import { Settings } from "@/pages/settings";

export const dashboardRoutes = {
    title: "MAIN",
    type: "section",
    items: [
        {
            path: "/",
            title: "Dashboard",
            component: <Dashboard />,
            icon: <LuLayoutDashboard />,
            permission: null,
        },
        {
            path: "/profile",
            title: "Profil Saya",
            component: <Profile />,
            permission: null,
            type: "hidden",
        },
        {
            path: "/settings",
            title: "Pengaturan",
            component: <Settings />,
            permission: null,
            type: "hidden",
        },
    ],
};
